import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../../shared/nestjs/nest-api";
import { Observable } from "rxjs";
import { SFShiftDailyApi } from "../../../shared/sdk/services/custom";
import {
  RequestAddDto,
  RequestAddNewShiftPatternDto,
  RequestCheckBeforeDeletePatternDto,
  RequestEditDto,
  RequestEditShiftPatternDto,
  RequestEditShiftPatternNameDto,
  ResponseGetOvertimeCode,
} from "../../../shared/nestjs/gd-only/dto/shift-daily.dto";
import { ShiftDailyApi } from "../../../shared/nestjs/gd-only/services/shift-daily.api";
import { map } from "rxjs/operators";
import { OvertimeRequestApiProvider } from "../../../shared/nestjs/overtime/overtime-request-api";

@Injectable()
export class ShiftDailySettingBloc {
  constructor(
    private nestApiProvider: NestApiProvider,
    private sfshiftdailyApi: SFShiftDailyApi,
    private shiftDailyApi: ShiftDailyApi,
    private overtimeRequestApiProvider: OvertimeRequestApiProvider,
  ) {
  }

  /**
   * SHIFT DAILY
   */

  editShiftDaily(params: RequestEditDto): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.shiftDailyApi.edit(params)
        } else {
          return this.sfshiftdailyApi.edit(params)
        }
      }
      )
  }

  addShiftDaily(params: RequestAddDto): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.shiftDailyApi.add(params)
        } else {
          return this.sfshiftdailyApi.add(params)
        }
      }
      )
  }

  getOvertimeCode() {
    return new Promise<ResponseGetOvertimeCode>((resolve, reject) => {
      this.shiftDailyApi.getOvertimeCode()
        .map(res => res.data)
        .subscribe(result => {
          resolve(result);
        }, error => {
          reject(error);
        })
    })
  }


  /**
   * SHIFT PATTERN
   */
  getShiftPatternsListing(): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.shiftDailyApi.getShiftPatternsListing()
            .pipe(
              map(res => res.data)
            );
        } else {
          return this.sfshiftdailyApi.getShiftPatternsListing()
        }
      }
      )
  }

  getShiftPatternsListingNew(payload, queryParams): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.shiftDailyApi.getShiftPatternsListingNew(payload, queryParams)
        }
      }
      )
  }

  checkBeforeDeletePattern(payload: RequestCheckBeforeDeletePatternDto): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.shiftDailyApi.checkBeforeDeletePattern(payload)
            .pipe(
              map(res => res.message)
            );
        } else {
          return this.sfshiftdailyApi.checkBeforeDeletePattern(payload.shiftgroupcode)
        }
      }
      )
  }

  addNewShiftPattern(payload: RequestAddNewShiftPatternDto): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.shiftDailyApi.addNewShiftPattern(payload)
            .pipe(
              map(res => res.message)
            );
        } else {
          return this.sfshiftdailyApi.addNewShiftPattern(payload.shiftgroupname)
        }
      }
      )
  }

  editShiftPatternName(payload: RequestEditShiftPatternNameDto): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.shiftDailyApi.editShiftPatternName(payload)
            .pipe(
              map(res => res.message)
            );
        } else {
          return this.sfshiftdailyApi.editShiftPatternName(payload)
        }
      }
      )
  }

  getOvertimeBaseOn(): Observable<any> {
    return this.overtimeRequestApiProvider.getOvertimeBaseOn()
      .pipe(
        map(res => res.data)
      );
  }

  editShiftPattern(payload: RequestEditShiftPatternDto): Observable<any> {
    return this.shiftDailyApi.editShiftPattern(payload)
      .pipe(
        map(res => res.message)
      );
  }

}



// WEBPACK FOOTER //
// ./src/bloc/hr/shift/shift-daily-setting.bloc.ts